// extracted by mini-css-extract-plugin
module.exports = {"grid":"partner-grid-module--grid--ox2su"};